module.exports = __webpack_public_path__ + "img/alex-nice-hauntedplace-alexnice.5dee1bfd.jpg";